<template>
  <HighlightContainerCheckout
    title="Quais são os principais materiais das suas embalagens?"
    even
    class="pa-0"
  >
    <p class="text-body">
      Para realizar a compensação ambiental das suas embalagens, você deve
      escolher abaixo um ou dois dos materiais mais predominantes nelas.
    </p>
    <v-container>
      <v-row class="materials-wrapper">
        <v-col
          v-for="(material, key) of materials"
          :key="key"
          cols="12"
          md="6"
          xl="3"
        >
          <div class="material" :class="{ selected: material.selected }">
            <div class="material-content">
              <v-img :src="material.img" contain width="96" height="96" />
              <p class="name">
                {{ material.material }}
              </p>
              <p class="ma-0 description">
                {{ material.description }}
              </p>
            </div>
            <v-btn
              :class="{
                selected: material.selected,
              }"
              @click="
                selectMaterial(material);
                valueMaterial();
              "
            >
              <v-icon>
                {{
                  material.selected ? mdiSquareRounded : mdiSquareRoundedOutline
                }}
              </v-icon>
              {{ material.selected ? 'Selecionado' : 'Selecionar' }}
            </v-btn>
          </div>
        </v-col>
        <!-- <v-col cols="8" md="4">
          <v-row>
            <v-slider
              :key="`${key}-slide`"
              v-model="material.value"
              :color="material.color"
              :disabled="!material.selected"
              :readonly="materialsSelecteds().length === 1"
              min="0"
              max="100"
              :label="`${material.value}%`"
              @change="valueMaterial(material)"
            />
          </v-row>
          <v-row>
            <p style="font-size: 12px">
              {{ material.description }}
            </p>
          </v-row>
        </v-col> -->
      </v-row>
    </v-container>
  </HighlightContainerCheckout>
</template>

<script>
import { mdiSquareRoundedOutline, mdiSquareRounded } from '@mdi/js';

export default {
  name: 'Step3',
  components: {
    HighlightContainerCheckout: () =>
      import('@/components/HighlightContainerCheckout.vue'),
  },
  data() {
    return {
      mdiSquareRoundedOutline,
      mdiSquareRounded,
      materials: [
        {
          id: 1,
          material: 'Plástico',
          material_name: 'plastic',
          color: '#d40133',
          img: require('@/assets/images/checkout/materials/plastic.png'),
          description: 'PET, PEAD, PVC, PEBD, PP, PS e outros.',
          value: 0,
          selected: false,
        },
        {
          id: 2,
          material: 'Vidro',
          material_name: 'glass',
          color: '#01ee55',
          img: require('@/assets/images/checkout/materials/glass.png'),
          description: 'Vidros em geral, de todas as cores e tipos.',
          value: 0,
          selected: false,
        },
        {
          id: 3,
          material: 'Papel',
          material_name: 'paper',
          color: '#00a4e5',
          img: require('@/assets/images/checkout/materials/paper.png'),
          description:
            'Papéis rígidos, flexível, papelão, embalagens cartonadas e outros.',
          value: 0,
          selected: false,
        },
        {
          id: 4,
          material: 'Metal',
          material_name: 'metal',
          color: '#ff5d01',
          img: require('@/assets/images/checkout/materials/metal.png'),
          description: 'Alumínio, aço e outros.',
          value: 0,
          selected: false,
        },
      ],
    };
  },
  mounted() {
    this.getStoreMaterial();
    this.changeColor();
  },
  methods: {
    materialsSelecteds() {
      return this.materials.filter(selected => selected.selected);
    },
    selectMaterial(material) {
      const selecteds = this.materialsSelecteds();
      if (material.selected) {
        material.selected = !material.selected;
        material.value = 0;
      } else if (selecteds.length < 4) {
        material.selected = !material.selected;

        if (selecteds.length === 1) {
          material.value = 50;
          selecteds[0].value -= material.value;
        }
      }
    },
    valueMaterial() {
      const selecteds = this.materialsSelecteds();
      if (selecteds.length === 1) {
        selecteds[0].value = 100;
      }
      if (selecteds.length >= 2) {
        // const currentMaterial = selecteds.findIndex(({ id }) => m.id === id);
        selecteds.forEach(item => {
          if (selecteds.length === 3) {
            const floatNumber = 100 / selecteds.length;
            item.value = floatNumber.toFixed(2);
          } else {
            item.value = 100 / selecteds.length;
          }
        });
        // if (currentMaterial >= 0) {
        //   selecteds[!currentMaterial ? 1 : 0].value = 100 - m.value;
        // }
      }

      this.postStoreMaterial();
    },
    getStoreMaterial() {
      this.materials = this.$store.getters.materials.length
        ? this.$store.getters.materials
        : this.materials;
    },
    postStoreMaterial() {
      if (this.materialsSelecteds().length >= 1) {
        const selecteds = this.materialsSelecteds();

        this.$store.commit('changeMaterials', selecteds);
      } else {
        this.$store.commit('changeMaterials', []);
      }
    },
    changeColor() {
      this.materials.forEach(item => {
        if (item.material_name === 'glass') {
          item.color = '#26d07c';
        }
      });
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.materials-wrapper
  >div
    @media screen and (max-width: 959px)
      padding: 0 5px 30px 0
      .material
        .v-btn
          margin-top: 15px
    @media screen and (min-width: 960px) and (max-width: 1903px)
    padding-right: 40px
    padding-left: 0
    padding-bottom: 30px
    &:nth-child(1)
      .material
        &.selected,
        &:hover
          border-left-color: #EF3340
    &:nth-child(2)
      .material
        &.selected,
        &:hover
          border-left-color: #26D07C
    &:nth-child(3)
      .material
        &.selected,
        &:hover
          border-left-color: #147BD1
    &:nth-child(4)
      .material
        &.selected,
        &:hover
          border-left-color: #ECF166
    .material
      background: #FFFFFF
      display: flex
      flex-flow: column
      justify-content: space-between
      border-left: 8px solid #CDCDD0
      box-shadow: 0px 4px 8px rgba(7, 8, 23, 0.16)
      border-radius: 8px
      padding: 16px 24px
      transition: all 400ms ease-in-out
      @media screen and (min-width: 960px)
        min-height: 300px
      @media screen and (min-width: 1280px)
        min-height: 280px
      @media screen and (min-width: 1904px)
        min-height: 300px
      .material-content
        display: flex
        gap: 20px
        flex-flow: wrap
        .v-image
          background: #F2F2F3
          border-radius: 16px
          margin-bottom: 25px
          flex-grow: 0
          ::v-deep
            .v-image__image
              max-height: 76px
              margin-top: 10px
        .name,
        .description
          line-height: 1
          color: #003036
        .name
          font-family: 'metropolisbold', sans-serif
          font-weight: 700
          font-size: 1.25rem
          margin: 0
          margin-bottom: 20px
        .description
          font-family: 'metropolisregular', sans-serif
          font-weight: 400
          font-size: 1rem
          width: 100%
      &.selected,
      &:hover
        transition: all 400ms ease-in-out
      .v-btn
        background-color: #F2F2F3 !important
        color: #003036 !important
        text-transform: inherit
        width: 100%
        border: 2px solid #CDCDD0
        border-radius: 8px
        font-size: 1rem
        letter-spacing: 0
        text-transform: uppercase
        padding: 22px 0
        box-shadow: none
        transition: all 400ms ease-in-out
        .v-icon
          font-size: 1rem
          color: #003036
          margin-right: 10px
        &.selected,
        &:hover
          background-color: #EEFBF5 !important
          border: 2px solid #26D07C
          transition: all 400ms ease-in-out
          .v-icon
            color: #003036

.wrapper
  ::v-deep
    .title
      text-align: left !important
      font-size: 2rem !important
      font-weight: 600 !important
    .title + .row
      justify-content: flex-start !important
      .separator
        width: 50%
        height: 4px
        margin-top: 10px
        @media screen and (max-width: 959px)
          width: 80%
          height: 2px
</style>
